import './css/Modal.css';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

interface Question {
  questionId?: string;
  text?: string;
  questionText?: string;
  type: string;
  required: boolean;
  options?: Array<{ label: string; value: string }>;
}

interface ModalProps {
  id: string;
  questionnaireName: string;
  questions: Question[];
  contentType: string;
}

const Modal: React.FC<ModalProps> = ({ id, questionnaireName, questions, contentType }) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Modal Questions:', questions); // Debug log
  }, [questions]);

  const handleEdit = () => {
    // Close modal before navigation
    const modalElement = document.getElementById(`modal-${id}`);
    if (modalElement) {
      const modalInstance = (window as any).jQuery(modalElement).modal('hide');
      if (modalInstance) {
        modalInstance.modal('hide');
      }
    }
    // Navigate to questionnaire builder with ID
    navigate(`/recruiter/questionnaire-builder/${id}`);
  };

  return (
    <div 
      className="modal fade" 
      id={`modal-${id}`} 
      tabIndex={-1} 
      role="dialog"
      aria-labelledby={`modal-${id}-label`} 
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={`modal-${id}-label`}>Preview</h5>
            <button 
              type="button" 
              className="close" 
              data-dismiss="modal" 
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6 text-align-left">
                <h4>{questionnaireName}</h4>
                <p>Manage job posts using question set or link new job posts</p>
                <div className="d-inline-flex align-items-center border px-2 py-1 mb-5 text-secondary" style={{ borderRadius: '10px' }}>
                  {/* <i className={`fas ${contentType === 'Video' ? '/svgs/video.svg' : contentType === 'Audio' ? '/svgs/mic.svg' : ''} mr-2`}></i> */}
                  <img 
                        src={contentType === 'Video' ? '/svgs/video.svg' : contentType === 'Audio' ? '/svgs/mic.svg' : ''}
                        alt={contentType} 
                        width="16" 
                        height="16" 
                        className="text-secondary" 
                      />
                      <span className="ml-2">
                        {contentType}
                      </span>
                </div>
                
                <div className="questions-container">
                  {Array.isArray(questions) && questions.length > 0 ? (
                    questions.map((question, index) => (
                      <div key={question.questionId || `question-${index}`} className="question-item mb-4">
                        <h6 className="question-text">
                          {index + 1}. {question.questionText || question.text}
                        </h6>
                        {question.type !== 'text' && question.options && (
                          <ul className="list-unstyled pl-4">
                            {question.options.map((option, optIndex) => (
                              <li key={optIndex} className="option-item mb-2">
                                • {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No questions available</p>
                  )}
                </div>
              </div>
              <div className="col-lg-6 text-align-left">
                <button 
                  className="btn btn-outline-primary float-right"
                  onClick={handleEdit}
                  id="edit-questionnaire-button"
                >
                  <i className="fa fa-edit mr-2"></i>Edit Questionnaire
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
